import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-foreground-950 text-foreground-100">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div className="lg:col-span-1">
            <h3 className="font-heading text-xl font-bold mb-3">AllChinaBuy</h3>
            <p className="text-sm text-foreground-300 leading-relaxed mb-4">
              {t('footer.description')}
            </p>
            <div className="flex items-center gap-4">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-300 hover:text-background-50 transition-colors">
                <i className="ri-external-link-line text-lg" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-foreground-300 mb-4">
              {t('footer.links')}
            </h4>
            <ul className="space-y-2">
              <li>
                <a href="/" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">
                  {t('nav.home')}
                </a>
              </li>
              <li>
                <a href="/allchinabuy-spreadsheet/" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">
                  {t('nav.spreadsheet')}
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">
                  {t('nav.guides')}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-foreground-300 mb-4">
              {t('footer.resources')}
            </h4>
            <ul className="space-y-2">
              <li>
                <a href="/allchinabuy-spreadsheet/" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">
                  AllChinaBuy Spreadsheet
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">
                  {t('nav.shipping')}
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">
                  {t('nav.qc')}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-foreground-300 mb-4">
              {t('footer.legal')}
            </h4>
            <ul className="space-y-2">
              <li>
                <span className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                  {t('footer.privacy')}
                </span>
              </li>
              <li>
                <span className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                  {t('footer.terms')}
                </span>
              </li>
              <li>
                <span className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                  {t('footer.disclaimer')}
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800">
          <p className="text-xs text-foreground-400 text-center mb-2">
            {t('footer.disclaimer_text')}
          </p>
          <p className="text-xs text-foreground-400 text-center">
            {t('footer.copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
}